(function () {
  'use strict';

  let angular = window.angular;

  SupportAdminLinkController.$inject = ['Var', 'AppUtils', 'LocalStorageService'];

  angular.module('app').component('supportAdminLinkModal', {
    template:'<form name="$ctrl.addUsersForm" class="validate" novalidate autocomplete="off"><div class="modal-header"><span translate>entities.organization.actions.linkUser</span></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="form-group"><label class="control-label" translate>entities.user.modelNamePl</label><ui-select multiple ng-model="$ctrl.selectedUsers" theme="bootstrap" close-on-select="false" title="Seleccione usuarios"><ui-select-match translate-attr="::{placeholder: \'entities.organization.actions.selectUsers\'}">{{$item.name}} {{$item.surname || \'\'}}</ui-select-match><ui-select-choices repeat="user in $ctrl.availableUsers | filter:$select.search track by user.id"><div><strong ng-bind="user.name + \' \' + (user.surname || \'\')"></strong><br><small ng-if="user.username">@{{user.username}}</small></div></ui-select-choices></ui-select></div></div></div></div><div class="alert alert-warning no-margin text-center" ng-show="$ctrl.saveError">{{$ctrl.saveError}}</div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" ng-click="$ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button type="button" class="btn btn-primary" ng-click="$ctrl.linkUser()" ng-disabled="!$ctrl.selectedUsers.length" translate>buttons.add</button></div></form><div style="position: relative; height: 200px" ng-show="$ctrl.saving"><spinner css-class="\'small\'" show="$ctrl.saving"></spinner></div>',
    controller: SupportAdminLinkController,
    controllerAs: '$ctrl',
    bindings: {
      modalInstance: '<',
      resolve: '<',
    },
  });

  function SupportAdminLinkController(Var, utils, LocalStorageService) {
    let vm = this;

    vm.$onInit = function onInit() {
      vm.users = vm.resolve.users;
      vm.varId = vm.resolve.varId;
      vm.linkUser = linkUser;
      vm.selectedUsers = [];
      vm.availableUsers = vm.users.filter(function (user) {
        return !user.vars.some(function (item) {
          return item.id === vm.varId;
        });
      });
    };

    function linkUser() {
      if (!vm.selectedUsers.length) {
        return;
      }

      vm.loading = true;

      const addPromises = vm.selectedUsers.map(function (user) {
        return Var.prototype$__link__supportAdmins(
          {
            id: vm.varId,
            fk: user.id,
          },
          {}
        ).$promise;
      });

      Promise.all(addPromises)
        .then(function () {
          vm.loading = false;
          vm.modalInstance.close();
        })
        .catch(function (err) {
          vm.loading = false;
          let error = utils.getHTTPError(err);
          vm.LinkUserError = error.code || error.message;
        });
    }
  }
})();
